import React from 'react';
import { ShowButton, Datagrid, DateField, TextField, Filter, SelectInput, TextInput } from 'react-admin';
import TList from 'cw-core-admin-ui/src/components/wrapper/TList';
import { LinkField } from 'cw-core-admin-ui/src/components/fields';
import { marketplaceStatusForSelection } from './MarketplaceConstants';

const MarketplaceFilter = (props) => (
	<Filter {...props}>
		<TextInput resettable source="walletId" label="resources.marketplaces.filter.walletId" />
		<TextInput resettable source="name" label="resources.marketplaces.filter.name" />
		<SelectInput resettable source="status" label="resources.marketplaces.filter.status" choices={marketplaceStatusForSelection} />
	</Filter>
);

export default ({ marketplaceStatusForSelection, ...props }) => (
	<TList exporter={false} {...props} filters={<MarketplaceFilter />}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<TextField source="name" />
			<TextField source="status" />
			<LinkField source="walletId" type="Wallet" />
			<DateField source="creationDateTime" showTime />
		</Datagrid>
	</TList>
);
